import type { Translation } from "../types";

const zh: Translation = {
    // Navigation
    "nav.home": "首页",
    "nav.tools": "工具",
    "nav.minddeck": "MindDeck",
    "nav.jsonparser": "JSON解析器",
    "nav.guide": "指南",
    "nav.about": "关于",
    "nav.contact": "联系",
    "nav.faq": "常见问题",
    "nav.privacy": "隐私政策",
    "nav.terms": "使用条款",
    "nav.changelog": "更新日志",
    "nav.roadmap": "路线图",

    // Common
    "common.loading": "加载中...",
    "common.error": "发生错误",
    "common.back": "返回",
    "common.next": "下一步",
    "common.previous": "上一步",
    "common.search": "搜索",
    "common.menu": "菜单",
    "common.close": "关闭",
    "common.learnMore": "了解更多",

    // Home
    "home.title": "为开发者和学习者提供的工具",
    "home.subtitle": "通过高效直观的网络工具提升您的生产力",
    "home.tools.title": "可用工具",
    "home.minddeck.title": "MindDeck",
    "home.minddeck.desc": "智能闪卡学习工具",
    "home.jsonparser.title": "JSON差异解析器",
    "home.jsonparser.desc": "JSON结构比较和分析工具",
    "home.features.title": "主要特点",
    "home.features.performance.title": "快速性能",
    "home.features.performance.desc": "使用优化的网络技术进行快速高效的处理",
    "home.features.security.title": "安全使用",
    "home.features.security.desc": "客户端处理确保数据安全",
    "home.features.multilingual.title": "多语言支持",
    "home.features.multilingual.desc": "支持韩语、英语、日语和中文",
    "home.cta.title": "立即开始",
    "home.cta.subtitle": "免费使用所有提供的工具",
    "home.cta.minddeck": "开始使用MindDeck",
    "home.cta.jsonparser": "使用JSON解析器",
    "home.learnMore": "了解更多",

    // About
    "about.title": "关于 MewSeeds",
    "about.subtitle": "我们是为开发者和学习者打造创新 Web 工具的团队。",
    "about.stats.tools": "可用工具",
    "about.stats.languages": "支持语言",
    "about.stats.users": "用户",
    "about.stats.uptime": "运行时间",
    "about.mission.title": "我们的使命",
    "about.mission.description":
        "我们简化复杂任务，提供帮助开发者和学习者更高效工作的工具。我们优先考虑用户体验，持续创新以创造更好的解决方案。",
    "about.values.title": "核心价值观",
    "about.values.innovation.title": "创新",
    "about.values.innovation.desc": "我们利用最新技术提供最佳用户体验。",
    "about.values.userFirst.title": "用户至上",
    "about.values.userFirst.desc": "我们基于用户需求和反馈开发产品。",
    "about.values.privacy.title": "隐私保护",
    "about.values.privacy.desc": "我们保护用户隐私并提供安全服务。",
    "about.values.openSource.title": "开源",
    "about.values.openSource.desc": "我们通过透明度和协作创造更好的工具。",
    "about.techStack.title": "技术栈",
    "about.contact.title": "联系我们",
    "about.contact.description": "如有任何问题或建议，请随时联系我们。",
    "about.contact.email": "发送邮件",
    "about.contact.github": "GitHub",

    // Footer
    "footer.copyright": "© 2025 MewSeeds. All rights reserved.",
    "footer.madeWith": "MewSeeds，为了更美好的世界",
    "footer.links": "快速链接",
    "footer.tools": "工具",
    "footer.support": "支持",
    "footer.contact": "联系方式",
    "footer.goto.minddeck": "前往 MindDeck",
    "footer.goto.jsonparser": "前往 JSON Parser",

    // Guide
    "guide.title": "用户指南",
    "guide.subtitle": "分步介绍如何高效使用 MewSeeds 的所有工具。",
    "guide.minddeck.title": "MindDeck 使用指南",
    "guide.minddeck.desc": "逐步了解基于抽认卡的学习工具 MindDeck 的所有功能。",
    "guide.minddeck.step1": "创建账号并登录",
    "guide.minddeck.step2": "创建新牌组",
    "guide.minddeck.step3": "添加和编辑卡片",
    "guide.minddeck.step4": "开始学习模式",
    "guide.minddeck.step5": "跟踪进度并查看统计数据",
    "guide.jsonparser.title": "JSON Parser 使用方法",
    "guide.jsonparser.desc": "学习如何高效处理和转换 JSON 数据。",
    "guide.jsonparser.step1": "输入 JSON 数据",
    "guide.jsonparser.step2": "语法验证和错误检查",
    "guide.jsonparser.step3": "数据格式转换",
    "guide.jsonparser.step4": "过滤和排序功能",
    "guide.jsonparser.step5": "导出结果",
    "guide.stepsTitle": "分步指南",
    "guide.tipsTitle": "高效学习小贴士",
    "guide.tipsDesc": "提升学习体验的实用建议",
    "guide.tip1.title": "定期学习",
    "guide.tip1.desc": "每天坚持学习，即使只有一点点，也是最有效的。",
    "guide.tip2.title": "实践为主的学习",
    "guide.tip2.desc": "不要只学理论，实际操作工具试试看。",
    "guide.tip3.title": "善用社区",
    "guide.tip3.desc": "与其他用户分享经验和技巧。",
    "guide.tip4.title": "收集反馈",
    "guide.tip4.desc": "使用过程中发现的问题或建议请告知我们。",
    "guide.ctaTitle": "立即开始体验",
    "guide.ctaDesc": "跟着指南实际操作各类工具。",
    "guide.cta.minddeck": "开始使用 MindDeck",
    "guide.cta.jsonparser": "开始使用 JSON Parser",
    "guide.modalTitle": "视频指南制作中",
    "guide.modalDesc": "请稍等片刻！",

    // Tools
    "tools.subtitle": "助力开发与学习的网页工具合集",
    "tools.minddeck.desc": "基于智能间隔重复算法的高效记忆工具",
    "tools.minddeck.feature1": "间隔重复算法",
    "tools.minddeck.feature2": "进度追踪",
    "tools.minddeck.feature3": "支持深色模式",
    "tools.minddeck.feature4": "移动端优化",
    "tools.jsonparser.desc": "可视化对比和分析 JSON 数据结构的工具",
    "tools.jsonparser.feature1": "实时对比",
    "tools.jsonparser.feature2": "差异可视化",
    "tools.jsonparser.feature3": "错误校验",
    "tools.jsonparser.feature4": "客户端处理",
    "tools.detail": "了解更多",
    "tools.useNow": "立即使用",
    "tools.coming.title": "更多工具即将上线",
    "tools.coming.desc": "我们正在开发 AI 翻译器、数据可视化等实用工具。",
    "tools.roadmap": "查看路线图",

    // ToolMindDeck
    "minddeck.header.title": "MindDeck",
    "minddeck.header.desc1": "基于抽认卡的智能学习工具",
    "minddeck.header.desc2": "高效记忆与重复学习，人人都能轻松掌握！",
    "minddeck.features.title": "主要功能",
    "minddeck.features.1.title": "创建/管理抽认卡",
    "minddeck.features.1.desc": "可轻松添加、编辑和删除卡片。",
    "minddeck.features.2.title": "智能间隔重复学习",
    "minddeck.features.2.desc": "通过间隔重复算法高效记忆。",
    "minddeck.features.3.title": "进度追踪与统计",
    "minddeck.features.3.desc": "可直观查看学习进度和成就。",
    "minddeck.features.4.title": "多语言/深色模式支持",
    "minddeck.features.4.desc": "随时随地、各种环境下都能学习。",
    "minddeck.steps.title": "使用方法",
    "minddeck.steps.1": "通过添加抽认卡创建新牌组，或加载已有牌组。",
    "minddeck.steps.2": "将需要记忆的内容以卡片形式添加到牌组中。",
    "minddeck.steps.3": "开始学习模式，反复学习抽认卡。",
    "minddeck.steps.4":
        "边学习边查看进度和统计。可在牌组内添加、删除、编辑卡片。",
    "minddeck.usecases.title": "应用示例",
    "minddeck.usecases.1": "英语单词、汉字、历史年代等记忆科目学习",
    "minddeck.usecases.2": "编程语法、术语、算法记忆",
    "minddeck.usecases.3": "资格考试准备、面试准备",
    "minddeck.usecases.4": "需要反复学习的所有领域，如工作手册、产品信息等",
    "minddeck.faq.title": "常见问题（FAQ）",
    "minddeck.faq.1.q": "可以在手机上使用吗？",
    "minddeck.faq.1.a":
        "可以，MindDeck 在手机和桌面端都能流畅运行。在手机 Chrome 上点击右上角菜单，选择'添加到主屏幕'-'安装应用'，即可像应用一样使用网站。",
    "minddeck.faq.2.q": "学习数据安全吗？",
    "minddeck.faq.2.a":
        "MindDeck 不会存储任何学习数据，所有数据仅保存在用户浏览器中。",
    "minddeck.faq.3.q": "可以免费使用吗？",
    "minddeck.faq.3.a": "可以，MindDeck 对所有人免费开放。",
    "minddeck.cta": "前往 MindDeck",

    // ToolJsonParser
    "json.header.title": "JSON Parser",
    "json.header.desc1": "JSON 排序、对比、查看功能一站式体验！",
    "json.header.desc2": "轻松快速分析复杂 JSON 数据。",
    "json.features.title": "主要功能",
    "json.features.1.title": "JSON 排序",
    "json.features.1.desc": "让复杂的 JSON 数据更易阅读和整理。",
    "json.features.2.title": "JSON 对比",
    "json.features.2.desc": "一目了然地对比两个 JSON 数据的差异。",
    "json.features.3.title": "JSON 查看器",
    "json.features.3.desc": "以树形结构轻松浏览和分析 JSON。",
    "json.steps.title": "使用方法",
    "json.steps.1": "选择排序、对比或查看等所需功能。",
    "json.steps.2": "输入 JSON 数据。",
    "json.steps.3": "查看结果，如有需要可复制。",
    "json.usecases.title": "应用示例",
    "json.usecases.1": "API 响应数据分析",
    "json.usecases.2": "不同版本 JSON 结构对比",
    "json.usecases.3": "复杂 JSON 树可视化",
    "json.usecases.4": "数据转换与格式化",
    "json.faq.title": "常见问题（FAQ）",
    "json.faq.1.q": "可以处理大容量 JSON 吗？",
    "json.faq.1.a":
        "可以，大多数大容量 JSON 都能快速处理。但受限于浏览器内存，可能存在限制。",
    "json.faq.2.q": "可以保存 JSON 对比结果吗？",
    "json.faq.2.a": "可以，结果可复制或下载为文件。",
    "json.faq.3.q": "可以在手机上使用吗？",
    "json.faq.3.a":
        "可以，移动端同样优化良好。在手机 Chrome 上点击右上角菜单，选择'添加到主屏幕'-'安装应用'，即可像应用一样使用网站。",
    "json.cta": "前往 JSON Parser",

    // Sidebar
    "sidebar.toolsOverview": "工具介绍",
    "sidebar.companyInfo": "公司信息",

    // Privacy
    "privacy.title": "隐私政策",
    "privacy.lastUpdate": "最后更新: 2025年7月3日",

    // Terms
    "terms.title": "MewSeeds使用条款",
    "terms.lastUpdate": "最后更新: 2025年7月3日",
    "terms.section1.title": "第一条（目的）",
    "terms.section1.content":
        "本隐私政策旨在规定运营者（以下简称'运营者'）在运营MewSeeds及MewSeeds提供的所有子服务（以下简称'服务'）时，与服务提供相关的用户个人信息收集和使用的处理标准。",
    "terms.section2.title": "第二条（服务使用）",
    "terms.section2.content":
        "用户可以自由使用服务。用户在使用服务时必须遵守相关法律和本条款，不得妨碍其他用户使用服务或干扰服务的正常运行。用户未经运营者事先书面同意，不得商业性使用、复制、分发、传输、公开或创作衍生作品等使用服务提供的资料、信息、内容。用户不得冒充或未经授权使用运营者的名称（MewSeeds等）、标志、商标等。",
    "terms.section3.title": "第三条（知识产权）",
    "terms.section3.content":
        "MewSeeds的名称、标志、设计、程序、数据库、UI/UX等与服务相关的知识产权归运营者所有。如果用户违反本条款侵犯运营者的知识产权，运营者可以采取民事和刑事法律措施，并可以要求赔偿由此造成的损害。",
    "terms.section4.title": "第四条（广告）",
    "terms.section4.content":
        "运营者可以在服务画面等位置发布广告。用户承认在使用服务时可能会显示广告。运营者为服务的运营和免费提供而发布广告，并可能通过广告产生收益。运营者对用户通过广告参与或交易而产生的损害不承担责任。提供个性化广告所需的信息收集和使用遵循隐私政策。",
    "terms.section5.title": "第五条（免责条款）",
    "terms.section5.content":
        "运营者对因不可抗力原因如自然灾害、系统故障、服务器过载、黑客攻击、通信故障等无法提供服务的情况不承担责任。运营者不保证用户通过服务获得的信息或资料的准确性、完整性、有用性，对因信任或使用此类信息而产生的损害不承担责任。运营者对免费提供的服务，除非相关法律有特别规定，否则不承担损害赔偿责任。",
    "terms.section6.title": "第六条（争议解决及管辖）",
    "terms.section6.content":
        "运营者和用户应真诚协商解决与服务使用相关的争议。如果通过协商无法解决，可以向根据《内容产业振兴法》、《电子商交易等消费者保护法》等设立的争议调解机构申请争议调解。如果争议调解也无法解决或不愿调解，诉讼应向运营者住所地管辖法院提起。",
    "terms.section7.title": "第七条（附则）",
    "terms.section7.content": "本条款自2025年7月3日起生效。",
    "privacy.section1.title": "第一条（目的）",
    "privacy.section1.content":
        "本隐私政策旨在规定运营者（以下简称'运营者'）在运营MewSeeds及MewSeeds提供的所有子服务（以下简称'服务'）时，与服务提供相关的用户个人信息收集和使用的处理标准。",
    "privacy.section2.title": "第二条（收集的个人信息项目及方法）",
    "privacy.section2.content":
        "运营者可能为服务运营和咨询回复等目的收集以下个人信息：电子邮件地址（咨询时收集）、用户反馈中包含的信息（姓名、联系方式等用户自愿输入的内容）。运营者在服务使用时不会自动收集个人信息，但为提供个性化广告等目的可能会收集cookie等识别信息。用户可通过浏览器设置拒绝cookie收集。",
    "privacy.section3.title": "第三条（个人信息使用目的）",
    "privacy.section3.content":
        "运营者仅将收集的个人信息用于以下目的：用户咨询的回复和处理、遵守法律义务和纠纷应对、提供个性化广告（经同意的情况）",
    "privacy.section4.title": "第四条（个人信息保留及使用期限）",
    "privacy.section4.content":
        "收集的个人信息可能在咨询处理完成后保留一定期间，之后立即销毁。但根据法律需要保留一定期间的，可按相关法律规定的期间保留。电子商务法规定的交易记录：5年、通信秘密保护法规定的访问记录：3个月等",
    "privacy.section5.title": "第五条（个人信息第三方提供）",
    "privacy.section5.content":
        "运营者原则上不向第三方提供用户的个人信息。但在以下情况下可能例外提供：用户事先同意的情况、法律要求提供的情况",
    "privacy.section6.title": "第六条（个人信息保护负责人）",
    "privacy.section6.content": "姓名: MewSeeds、邮箱: mewseeds@gmail.com",
    "privacy.section7.title": "第七条（权利及行使方法）",
    "privacy.section7.content":
        "用户可随时要求运营者查阅、更正、删除、停止处理其个人信息，运营者将依法迅速采取措施。",
    "privacy.section8.title": "第八条（隐私政策变更）",
    "privacy.section8.content":
        "本政策自2025年7月3日起生效。运营者变更本政策时，将在实施前至少7天通知变更事项，重要事项提前30天通知。",

    // Contact
    "contact.title": "联系方式",
    "contact.subtitle": "如有任何问题或建议，欢迎随时联系我们。",
    "contact.infoTitle": "联系信息",
    "contact.emailTitle": "电子邮箱",
    "contact.emailDesc": "一般咨询或建议",
    "contact.siteTitle": "网站",
    "contact.siteDesc": "主网站",
    "contact.timeTitle": "回复时间",
    "contact.timeValue": "24小时内",
    "contact.timeDesc": "工作日快速回复",
    "contact.faqTitle": "常见问题",
    "contact.faq1.q": "服务是免费的吗？",
    "contact.faq1.a": "是的，所有工具均免费提供。",
    "contact.faq2.q": "如何提出功能建议？",
    "contact.faq2.a": "请通过电子邮件发送您的建议，我们会尽快审核并采纳。",
    "contact.faq3.q": "在哪里可以报告漏洞？",
    "contact.faq3.a": "请通过电子邮件详细描述漏洞，我们会尽快修复。",
};

export default zh;
